import mixpanel from 'mixpanel-browser';

const initMixpanel = () => {
  mixpanel.init(process.env.GATSBY_API_MIXPANEL_TOKEN, {
    api_host: process.env.GATSBY_MIXPANEL_HOST,
    debug: process.env.NODE_ENV === 'development',
    autocapture: true,
  });
};

export default initMixpanel;
